import { setSnackbar } from '@shared/library';
import { languages } from '@shared/library/dist/static/language';
import React from 'react';
import { /*useLocation,*/ useParams } from 'react-router-dom';
import config from '../../../config';
import './Test.scss';
//#region COMPONENTS
import DashboardControl from 'devexpress-dashboard-react';
import { KeyButton } from '../../_gest';
//#endregion
//CONTEXTS
import { CntxConfig } from '../../WebGest';

const DynamicDashboard = () => {
    //CONTEXTS
    const cntxConfig = React.useContext(CntxConfig)!;

    //#region STATIC DATA
    const locationParams = useParams();
    const lang = languages(cntxConfig.settings?.lang);
    //#endregion

    //STATES
    const [workingMode, setWorkingMode] = React.useState<'Designer' | 'Viewer' | 'ViewerOnly'>(cntxConfig.session?.userData?.role === 'admin' ? 'Viewer' : 'ViewerOnly');

    //#region METHODS
    const toggleWorkingMode = () => {
        if (cntxConfig.session?.userData?.role === 'admin') {
            if (workingMode === 'Designer') {
                setWorkingMode('Viewer');
                setSnackbar(cntxConfig, { message: lang.viewer_mode, severity: 'info' });
            }
            else {
                setWorkingMode('Designer');
                setSnackbar(cntxConfig, { message: lang.designer_mode, severity: 'warning' });
            }
        }

    };

    const handleKeyDown = (event: KeyboardEvent) => {
        // Verifica se shift e tab sono premuti contemporaneamente
        if (event.shiftKey && event.key === ' ') {
            // Esegui la tua funzione qui
            toggleWorkingMode();
        }
    };
    //#endregion

    //#region STATES CHANGE
    React.useEffect(() => {
        if (cntxConfig.session?.userData?.role === 'admin') {
            setSnackbar(cntxConfig, { message: <>{lang.press_shift_space_to_switch_working_mode} <KeyButton keyboardKey="Shift" icon={true} /> + <KeyButton keyboardKey="Space" /></>, severity: 'info' });
        }
    }, []);

    React.useEffect(() => {
        // Aggiungi l'ascoltatore degli eventi alla finestra quando il componente viene montato
        window.addEventListener('keydown', handleKeyDown);

        // Rimuovi l'ascoltatore degli eventi quando il componente viene smontato
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [workingMode]);
    //#endregion

    return (
        <div id="devExtreme">
            {cntxConfig.session?.userData && locationParams.id
                &&
                <DashboardControl
                    endpoint={`${config.api.internal}/DynamicDashboard`}

                    dashboardId={locationParams.id}
                    workingMode={workingMode}
                />

            }
        </div>
    );
};
export default DynamicDashboard;